export enum enmPdfRendererType {
    ReservationVoucher = 1,
    PDFTable = 2,
    EntryList = 3,
    ActionTemplate = 4,
    StopFreeSaleTemplate = 5,
    FactSheetTemplateLuxury = 6,
    FactSheetTemplateResort = 7,
    FactSheetTemplateCity = 8,
    FactSheetGiata = 9,
    ReservationList = 10
}
